import { Route, RouteGroup } from '@billow/easy-route'

export default RouteGroup({

  middleware: ['guest'],

  routes: [
    Route('/signup', 'signup', () => import('@/views/auth/SignUp.vue')),
    Route('/signin', 'signin', () => import('@/views/auth/SignIn.vue')),
    Route('/forgot-password', 'forgot-password', () => import('@/views/auth/ForgotPassword.vue')),
    Route('/reset-password', 'reset-password', () => import('@/views/auth/ResetPassword.vue')),
    Route('/two-factor-challenge', '2fa-challenge', () => import('@/views/auth/TwoFactorChallenge.vue')),
  ]
})